import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { fetchBlobImage } from "server/download";

const BlobImagePreview = ({
  url,
  alt = "Снимка",
  imgStyle,
  fallback = null,
  containerSx = { display: "flex", mt: 2 },
  reloadToken,
}) => {
  const [imgUrl, setImgUrl] = useState(null);

  useEffect(() => {
    if (!url) {
      setImgUrl(null);
      return;
    }

    let active = true;
    let objectUrl;

    const loadPhoto = async () => {
      try {
        const blob = await fetchBlobImage(url);
        if (!active) return;
        if (blob) {
          objectUrl = URL.createObjectURL(blob);
          setImgUrl(objectUrl);
        } else {
          setImgUrl(null);
        }
      } catch (err) {
        console.error("Неуспешно зареждане на снимка:", err);
      }
    };

    loadPhoto();

    return () => {
      active = false;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [url, reloadToken]);

  return (
    <Box sx={containerSx}>
      {imgUrl ? (
        <img
          src={imgUrl}
          alt={alt}
          style={imgStyle}
        />
      ) : (
        fallback
      )}
    </Box>
  );
};

export default BlobImagePreview;
